import React, { useRef } from 'react';
import {
  Stack,
  Text,
  DefaultButton,
  Image,
  IStackTokens,
  IComboBoxOption,
  Label,
  Icon,
} from '@fluentui/react';
import { AppContext } from '../../AppInRouterContext';
import useAsyncDataCourier from '../../common/custom-hooks/useAsyncDataCourier';
import { DatosIniciales } from './Steps/DatosIniciales';
import { Contacto } from './Steps/Contacto';
import { Confirmacion } from './Steps/Confirmacion';
import RegistroEntrenadorForm from '../RegistroEntrenador/RegistroEntrenadorForm';
import CustomInputIfc from '../../lib/FormValidator/Form/CustomInputIfc';
import useForceUpdate from '../../common/custom-hooks/useForceUpdate';
import { OtrosTitulos } from './Steps/OtrosTitulos';
import { useCustomInput } from '../../common/custom-hooks/useCustomInput';
import { Antiguedad } from './Steps/Antiguedad';
import { Cursos } from './Steps/Cursos';
import { Antecedentes } from './Steps/Antecedentes';
import { TituloSecundario } from './Steps/TituloSecundario';
import DialogTemplate from '../Common/DialogTemplate';

interface IWizardRegistroEntrenador {
  appContext: AppContext;
  getToken: () => Promise<string>;
}

export const checkMaxSize = (sizeInBytes: number) => {
  const limit = 20 * 1024 * 1024; // 50MB
  return sizeInBytes < limit;
};

const outerStackTokens: IStackTokens = { childrenGap: 20 };
const bodyStackTokens: IStackTokens = { childrenGap: 10 };

export const WizardRegistroEntrenador = (props: IWizardRegistroEntrenador) => {
  const [step, setStep] = React.useState(0);

  const [fileSelfie, setFileSelfie] = React.useState<File | null>(null);
  const [fileDocumento, setFileDocumento] = React.useState<File | null>(null);

  const [registroEntrenadorForm, setRegistroEntrenadorForm] = React.useState<RegistroEntrenadorForm>(RegistroEntrenadorForm.initialize());
  const forceUpdate = useForceUpdate();

  const [formIsValid, setFormIsValid] = React.useState(false);

  const [showDialog, setShowDialog] = React.useState<boolean>(false);
  const [entrenadorExistente, setEntrenadorExistente] = React.useState<boolean>(false);
  const [registroEntrenadorExistente,setRegistroEntrenadorExistente] = React.useState<boolean>(false);

  const [tituloSecundarioValido, setTituloSecundarioValido] = React.useState<boolean>(false);
  const [nextEnable, setNextEnable] = React.useState<boolean>(false);

  const tituloSecundarioRef = useRef<any>(null);

  const onBlurCustomInput = (customInput: CustomInputIfc) => {
    console.log(customInput, "******customInput");
    if (registroEntrenadorForm) {
      const isValid = registroEntrenadorForm.getIdInput().getValue()
        ? !registroEntrenadorForm.hasErrors()
        : registroEntrenadorForm?.isValid();
      setFormIsValid(isValid);
      forceUpdate();
      return isValid;
    }
    return false;
  };

  const onChangeForm = (value :boolean) => {
    console.log(value, "enable next");
    setNextEnable(value);
  }

  const save = async () => {
    try {
      props.appContext.changeBlockUI(true);
      const token = await props.getToken();
      const registroEntrenador = await props.appContext.system.getRegistroEntrenadorSystem().save(registroEntrenadorForm?.toRegistroEntrenador()!, token);
      const nextStep = step + 1;
      setStep(nextStep);
    } catch (err) {
      props.appContext.courier.messageError(err);
    } finally {
      props.appContext.changeBlockUI(false);
    }
  };


  const entrenadorExiste = async (dni: string) => {
    try {
      props.appContext.changeBlockUI(true);
      const [
        entrenadorResponse,
        registroResponse
      ] = await Promise.all([
        props.appContext.system.getRegistroEntrenadorSystem().checkEntrenadorExisteByDni(dni),
        props.appContext.system.getRegistroEntrenadorSystem().checkRegistroEntrenadorExisteByDni(dni)
      ]);
  
      
      if (entrenadorResponse.data) {
        setEntrenadorExistente(true);
      } else {
        setEntrenadorExistente(false);
      }
      
      if (registroResponse.data) {
        setRegistroEntrenadorExistente(true);
      } else {
        setRegistroEntrenadorExistente(false);
      }
  
      
      if (entrenadorResponse.data || registroResponse.data) {
        setShowDialog(true);
      }
  
    } catch (err) {
    
      setEntrenadorExistente(true);
      setRegistroEntrenadorExistente(true);
      props.appContext.courier.messageError(err);
    } finally {
      props.appContext.changeBlockUI(false);
    }
  };

  React.useEffect(() => {
    if (registroEntrenadorForm.getDocumentoNumeroInput().getValue()){
      entrenadorExiste(registroEntrenadorForm.getDocumentoNumeroInput().getValue());
    }
  }, [registroEntrenadorForm.getDocumentoNumeroInput().getValue()])

  const fotoInput = useCustomInput(() => registroEntrenadorForm.getFotoInput(), [registroEntrenadorForm]);
  const documentoImagenInput = useCustomInput(() => registroEntrenadorForm.getDocumentoImagenInput(), [registroEntrenadorForm]);

  React.useEffect(() => {
    console.log('FORM: ', registroEntrenadorForm);
  }, [registroEntrenadorForm])

  const clubes = useAsyncDataCourier(
    () => props.appContext.system.clubes(),
    [],
    props.appContext.courier,
    props.appContext.changeBlockUI
  );

  const documentoTipos = useAsyncDataCourier(
    () => props.appContext.system.documentoTipos(),
    [],
    props.appContext.courier,
    props.appContext.changeBlockUI
  );

  const reset = () => {
    setStep(0);
    setRegistroEntrenadorForm(RegistroEntrenadorForm.initialize());
  };

  const back = () => step > 0 && setStep(step - 1);
  const next = async () => {

    if (step === 6) {
      await save();
    } else if (step === 2) {
      addTituloSecundario();
      const nextStep = step + 1;
      setStep(nextStep);
    } else {
      const nextStep = step + 1;
      setStep(nextStep);
    }
  };

  const disableNext = () => {
    switch (step) {
      case 0:
        console.log('disable next age: ',
          !isFechaNacimientoValid()
        );
        return !registroEntrenadorForm.getApellidoInput().getValue() 
        || !registroEntrenadorForm.getNombreInput().getValue() 
        || !registroEntrenadorForm.getDocumentoNumeroInput().getValue() || !registroEntrenadorForm.getDtidInput().getValue() || !registroEntrenadorForm.getGeneroInput().getValue() || !registroEntrenadorForm.getFedIdInput().getValue() || !isNumberValid(registroEntrenadorForm.getDocumentoNumeroInput().getValue()) || entrenadorExistente || !isFechaNacimientoValid(); // Nombre, apellido, documento numero, documento tipo, documento imagen, genero y federacion son obligatorios para el paso 0
      case 1:
        return !registroEntrenadorForm.getEmailInput().getValue() || !validateEmail(registroEntrenadorForm.getEmailInput().getValue()) || !isNumberValid(registroEntrenadorForm.getTelMovilInput().getValue()) || !isNumberValid(registroEntrenadorForm.getCodPostalInput().getValue());
      case 2:
        return !tituloSecundarioValido;
      case 3:
        return !nextEnable;
      case 4:
        return !nextEnable; //agregué
      case 5:
        return !nextEnable;
      case 6:
        return !nextEnable;

      default:
        return false;
    }
  };

  const isFechaNacimientoValid = () => {
    if (registroEntrenadorForm.getFechaNacimientoInput().getValue()) {
      console.log('is adult: ', isAdult(registroEntrenadorForm.getFechaNacimientoInput().getValue()))
      return isAdult(registroEntrenadorForm.getFechaNacimientoInput().getValue());
    } else {
      console.log('true porque no hay fecha')
      return true;
    }
  }

  // React.useEffect(() => {
  //   console.log('disable next age: ',
  //     !isFechaNacimientoValid()
  //   );
  // }, [registroEntrenadorForm.getFechaNacimientoInput().getValue()]);

  const isNumberValid = (str: string) => {
    //solo chequea si el valor es un numero si no esta vacio/undefined
    if (str !== null && str !== undefined && str !== "") {
      return /^[0-9]+$/.test(str);
    } else {
      return true;
    }

  }

  const getSubtitleByStep = () => {
    switch (step) {
      case 0:
        return 'Ingresá tus datos';
      case 1:
        return 'Completá tus datos de contacto';
      case 2:
        return 'Título Secundario';
      case 3:
        return 'Otros Títulos ';
      case 4:
        return 'Antiguedad';
      case 5:
        return 'Cursos';
      case 6:
        return 'Antecedentes';
    }
  };

  const getCaptionByStep = () => {
    switch (step) {
      case 0:
        return 'Solo para Instructores/as y entrenadores/as de Handball que no tengan nivelación previa o a quienes les sea requerido el registro';
      case 1:
        return '';
      case 2:
        return 'Secundario completo';
      case 3:
        return '(En caso de títulos intermedios u obtenidos a lo largo de una misma carrera, en orden necesariamente sucesivo, se valorará solamente el obtenido en último término).';
      case 4:
        return 'Antiguedad';
      case 5:
        return 'No menores a 15 horas reloj de clase.';
      case 6:
        return 'Antecedentes';
    }
  };

  const showNextBtn = () => {
    return step !== 7;
  }

  const addTituloSecundario = () => {
    if (tituloSecundarioRef.current) {
      tituloSecundarioRef.current.addTitulo();
    }
  };

  return (
    <Stack
      verticalAlign="center"
      horizontalAlign="center"
      styles={{
        root: {
          height: '100vh',
          width: '100vw',
          backgroundColor: 'white', // Color de fondo para todo el contenedor
          color: 'white !important',
          justifyContent: 'normal'
        },
      }}
    >
      <Stack
        tokens={outerStackTokens}
        styles={{
          root: {
            width: 370,
            // height: 550,
            // boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
            // borderRadius: 8,
            padding: 10,
            // backgroundColor: '#ffffff',
          },
        }}
      >
        {/* Logo */}
        <Image height={80} src="/images/logo-eneha.png" alt="Logo" styles={{ root: { alignSelf: 'center' } }} />

        {/* Título */}
        <Text variant="large" styles={{ root: { textAlign: 'center', fontWeight: 'bold' } }}>
          Registro Nacional de Instructores/as y Entrenadores/as
          {/* <Text className='mt-2' block variant="small" styles={{ root: { textAlign: 'center', color: '#666' } }}>
            {apertura ? `Temporada: ${apertura.getTemporada()?.getDescripcion()}` : 'No hay apertura vigente'}
          </Text> */}
        </Text>

        {/* Subtítulo */}
        <Text variant="large" styles={{ root: { textAlign: 'center', color: '#666', fontWeight: 'bold' } }}>
          {getSubtitleByStep()}
        </Text>

        {/* Caption */}
        {/* <Text variant="medium" styles={{ root: { textAlign: 'center', color: '#666' } }}>
          {getCaptionByStep()}
        </Text> */}

        {/* Cuerpo */}
        <Stack
          grow
          tokens={bodyStackTokens}
          styles={{
            root: {
              flexGrow: 1,
              // minHeight: 300,
              // maxHeight: 300,
              // overflowY: 'auto', // Por si el contenido es largo
              // border: '1px solid #ddd',
              // borderRadius: 4,
              // padding: 10,
            },
          }}
        >
          {step === 0 && clubes && documentoTipos && (
            <DatosIniciales
              documentoTipos={documentoTipos}
              clubes={clubes}
              form={registroEntrenadorForm}
              onBlurCustomInput={onBlurCustomInput}
              system={props.appContext.system}
              courier={props.appContext.courier}
              onDropSelfie={(file: File) => {
                fotoInput.setValue(file);
              }}
              onDropDocumento={(file: File) => {
                documentoImagenInput.setValue(file);
              }}
              fileSelfie={fotoInput.getValue()}
              fileDocumento={documentoImagenInput.getValue()}
            ></DatosIniciales>
          )}
          {step === 1 && (
            <Contacto
              form={registroEntrenadorForm}
              onBlurCustomInput={onBlurCustomInput}
              system={props.appContext.system}
              courier={props.appContext.courier}
            ></Contacto>
          )}
          {step === 2 && (
            <TituloSecundario
              ref={tituloSecundarioRef}
              form={registroEntrenadorForm}
              onBlurCustomInput={onBlurCustomInput}
              system={props.appContext.system}
              courier={props.appContext.courier}
              nextStep={next}
              tituloSecundarioValido={tituloSecundarioValido}
              setTituloSecundarioValido={setTituloSecundarioValido}
            ></TituloSecundario>
          )}
          {step === 3 && (
            <OtrosTitulos
              form={registroEntrenadorForm}
              onBlurCustomInput={onBlurCustomInput}
              system={props.appContext.system}
              courier={props.appContext.courier}
              onNextEnable={onChangeForm}
            ></OtrosTitulos>
          )}
          {step === 4 && (
            <Antiguedad
              form={registroEntrenadorForm}
              onBlurCustomInput={onBlurCustomInput}
              system={props.appContext.system}
              courier={props.appContext.courier}
              appContext={props.appContext}
              onNextEnable={onChangeForm}
            ></Antiguedad>
          )}
          {step === 5 && (
            <Cursos
              form={registroEntrenadorForm}
              onBlurCustomInput={onBlurCustomInput}
              system={props.appContext.system}
              courier={props.appContext.courier}
              appContext={props.appContext}
              onNextEnable={onChangeForm}
            ></Cursos>
          )}
          {step === 6 && (
            <Antecedentes
              form={registroEntrenadorForm}
              onBlurCustomInput={onBlurCustomInput}
              system={props.appContext.system}
              courier={props.appContext.courier}
              appContext={props.appContext}
              onNextEnable={onChangeForm}
            ></Antecedentes>
          )}
          {step === 7 && (
            <Confirmacion
              entrenadorName={
                registroEntrenadorForm.getNombreInput().getValue() +
                ' ' +
                registroEntrenadorForm.getApellidoInput().getValue()
              }
              showEmailLegend={registroEntrenadorForm.getEmailInput().getValue() ? true : false}
              reset={reset}
            ></Confirmacion>
          )}
        </Stack>

        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm6">
              {step !== 0 && step !== 7 && (
                <Stack className="">
                  {/* <Text variant="medium" className="mt-1 link-styles">
              <span onClick={back}>Volver</span>
            </Text> */}
                  <DefaultButton onClick={back} text="Volver" />
                </Stack>
              )}
            </div>
            <div className="ms-Grid-col ms-sm6">
              {/* Botón de Siguiente */}
              {showNextBtn() && (
                <DefaultButton
                  disabled={disableNext()}
                  onClick={next}
                  text={step !== 6 ? 'Siguiente' : 'Finalizar'}
                  styles={{ root: { width: '100%' } }}
                  primary
                />
              )}
            </div>
          </div>
        </div>

        <Stack className='copyright-footer'>
          <Text variant="tiny" styles={{ root: { textAlign: 'center', color: '#666' } }}>
            LarrySport - Todos los derechos reservados
          </Text>
        </Stack>
      </Stack>

      <DialogTemplate
        showDialog={showDialog}
        toggleShowDialog={() => setShowDialog(!showDialog)}
        title={'Entrenador ya registrado'}
        onAccept={() => setShowDialog(!showDialog)}
        onCancel={() => {}}
        acceptText={'Entendido'}
        cancelText={''}
        hideCancelButton
        maxWidth={250}
      >
        <div>
          {registroEntrenadorExistente && entrenadorExistente && (
            <>
              <Text block style={{ fontWeight: 'bold' }}>
                Ya existe un entrenador y un registro activo con tu DNI.
              </Text>
              <Text block className="mt-2">
                Comunicate con tu delegado para recuperar tus datos de sesión.
              </Text>
            </>
          )}

          {registroEntrenadorExistente && !entrenadorExistente && (
            <>
              <Text block style={{ fontWeight: 'bold' }}>
                Ya existe un registro activo con tu DNI.
              </Text>
              <Text block className="mt-2">
                Comunicate con tu delegado para recuperar tus datos de sesión.
              </Text>
            </>
          )}

          {!registroEntrenadorExistente && entrenadorExistente && (
            <>
              <Text block style={{ fontWeight: 'bold' }}>
                Ya existe un entrenador registrado con tu DNI.
              </Text>
              <Text block className="mt-2">
                Comunicate con tu delegado para recuperar tus datos de sesión.
              </Text>
            </>
          )}
        </div>
      </DialogTemplate>
    </Stack>
  );
};

export const formatFileSize = (size: number): string => {
  if (size < 0) {
    throw new Error('El tamaño no puede ser negativo.');
  }

  const units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  let index = 0;

  while (size >= 1024 && index < units.length - 1) {
    size /= 1024;
    index++;
  }

  return `${size.toFixed(2)} ${units[index]}`;
};

export const obtenerExtension = (archivo: string): string | null => {
  const partes = archivo.split('.');
  return partes.length > 1 ? partes.pop() || null : null;
};

export const validateEmail = (email: string) => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const validatePhone = (phone: string) => {
  const re = /^\d+$/;
  return re.test(phone);
}

export const isAdult = (birthDate: Date) => {
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }

    return age >= 18;
  }
